/**
 * Translation service
 * Description: local cache clears on application reload (stop/start)
 */
services.service('LocaleService',
    ['$q', '$http', 'config', 'constants', 'ErrorService', 'LocalStorage', 'messages', 'Utils',
        function ($q, $http, config, Const, ErrorService, LocalStorage, messages, Utils) {
            var self = this,
                cache = {},
                langs = config.languagesPriority;

            self.lang = false;
            self.translation = {};
            self.translationPromise = $q.when(self.translation);
            self.messages = messages;

            /**
             * Return translation from local cache
             * @param lang
             * @returns {{data: *, lang: *}}
             */
            function getFromCache(lang) {
                if (cache.hasOwnProperty(lang) && !cache[lang].hasOwnProperty('_fallback')) {
                    return {
                        data: cache[lang],
                        lang: lang
                    };
                }
            }

            /**
             * Load language from remote source/local cache
             * @param lang
             * @returns {*}
             */
            function loadLang(lang) {
                var fromCache = getFromCache(lang);
                if (fromCache) return fromCache;

                return $http({
                    method: 'GET',
                    url: config.localizationPath + lang + '.json?' + Date.now(),
                    //url: 'locales/' + lang + '.json?' + Date.now(),
                    timeout: config.localizationLoadTimeout
                }).then(function (response) {
                    response.lang = lang;
                    return response;
                }).catch(function (err) {
                    throw new ErrorService({
                        source: 'LocaleService',
                        type: Const.error.type.SYSTEM,
                        severity: 'warning',
                        code: 'translationNotFound',
                        message: 'translation "' + lang + '" not found'
                    });
                })
            }

            this.wait = function () {
                return $q(function (resolve, reject) {
                    return self.translationPromise.then(resolve).catch(reject)
                })
            };

            this.replaceVars = function (from, to) {
                var re = new RegExp('\\$\\{' + from + '\\}', 'gi');
                Object.keys(self.translation).forEach(function (key) {
                    if (typeof  self.translation[key] === 'string') {
                        self.translation[key] = self.translation[key].replace(re, to);
                    }
                });
            };

            /**
             * Load translation
             * @param lang
             * @returns {*}
             */
            this.load = function (lang) {
                //first language
                var urlLang = Utils.getURLParameterByName('lang');
                var firstRun = lang || urlLang || LocalStorage.get('language') || config.defaultLanguage || langs.shift();

                function loadLangChain(arr) {
                    return arr.reduce(function (promise, item) {
                        return promise
                            .catch(function (err) {
                                return loadLang(item);
                            });
                    }, $q.when(loadLang(firstRun)));
                }

                //change state to loaded language
                function setLanguage(result) {
                    self.translation = result.data;
                    self.replaceVars('brandName', config.traderName);

                    self.lang = result.lang;
                    LocalStorage.set('language', self.lang);
                    self.translationPromise = $q.when(self.translation);
                    return result.data;
                }

                //update local cache
                function updateCache(translation) {
                    if (!self.translation._fallback) {
                        cache[self.lang] = self.translation;
                    }
                    return translation;
                }

                //run load chain
                return loadLangChain(langs)
                    .then(setLanguage)
                    .catch(function () {
                        log('Failed to load all translations - fallback to built-in en');
                        return setLanguage(getFromCache("en") || {data: messages, lang: 'en'})
                    })
                    .then(updateCache, updateCache)
            };

            return this;

        }]);
